import Enum from '@square/dashboard-utilities/utils/enum';
export default new Enum(['UNLINKED', 'LINKED', 'REFUND_TYPE_DO_NOT_USE']);